<template>
  <TsCard :appendClass="twMerge('text-left flex flex-col h-full max-w-[305px]', props.appendClass)"
          no-border
          no-shadow
          footer-class="mt-auto pt-3 border-t"
          :id="random_id"
          :data-testid="
      props.dataTestid ? props.dataTestid + 'with-ratings' : 'card-with-ratings'
    "
  >
    <slot name="content">
      <TsRatings appendClass="mb-2"
                 :modelValue="props.ratings"
                 :data-testid="
          props.dataTestid ? props.dataTestid + '-ratings' : 'card-ratings'
        "/>
      <slot name="content">
        <TsTypography
            v-if="!props.author"
            as="h4"
            :data-testid="
          props.dataTestid ? props.dataTestid + '-title' : 'card-title'
        "
        >{{ props.title }}
        </TsTypography>
        <TsTypography :appendClass="`text-left ${props.author && 'mb-4 pb-4 border-b'}`"
                      :data-testid="
          props.dataTestid
            ? props.dataTestid + '-description'
            : 'card-description'
        "
        >{{ props.description }}
        </TsTypography>
      </slot>
      <slot name="footer">
        <TsAvatar v-if="props.author" appendClass="font-semibold" size="lg"
                  :name="props.author?.username"
                  :description="props.author?.description"
                  :image="props.author?.avatar"
                  :data-testid="
              props.dataTestid
                ? props.dataTestid + '-author-avatar'
                : 'card-author-avatar'
            "
        />
      </slot>
    </slot>
  </TsCard>
</template>

<script setup lang="ts">
import {useRandomUUID} from "~/composables/useRandomUUID";
import {ref, onMounted} from "vue";
import {twMerge} from "tailwind-merge";

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const TsRatings = defineAsyncComponent(
    () => import('~/components/molecules/TsRatings.vue')
);

const TsAvatar = defineAsyncComponent(
    () => import('~/components/molecules/TsAvatar.vue')
);

type Author = {
  avatar?: string;
  description?: string;
  username?: string;
};

type Props = {
  dataTestid?: string;
  title?: string;
  description?: string;
  ratings?: number;
  author?: Author;
  appendClass?: string;
};
const props = withDefaults(defineProps<Props>(), {
  title: "High-Quality and Feature-Rich",
  description:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Consequunturnesciunt perspiciatis voluptates.",
  ratings: 4,
});
const random_id = ref("");

onMounted(() => {
  random_id.value = useRandomUUID();
});
</script>
